export const formatNumberWithCommas = (number) => {
  if (number === undefined || number === null) return "";
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Türkçe okunabilirlik için binlik ayracı olarak nokta kullanır (ör. 1.000.000).
export const formatThousandsDot = (value) => {
  const digits = String(value ?? "").replace(/\D/g, "");
  if (!digits) return "";
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};
